<template>
  <section class="Section Presta">
      <div class="Presta_wrapper">
        <div class="Presta_top">
          <h2>{{ data.primary.prestation_title }}</h2>
          <a :href="'/' + data.primary.link_target" class="Cta">{{ data.primary.link_label }}</a>
        </div>

        <div class="Presta_items">
          <PrestaPush :data="prestaPush" :key="i" v-for="(prestaPush, i) in data.items" />
        </div>
      </div>
    </section>
</template>

<script>
  import PrestaPush from "@/components/PrestaPush"
  import Fade from "@/components/Fade"

  export default {
    name: "PrestaList",
    props: [ 'data', 'direction', 'steps' ],
    components: {
      PrestaPush,
      Fade
    },
    data() {
      return {
        isMobile: false,
        swiperOption: {
          slidesPerView: 1.4,
          spaceBetween: 15,
          grabCursor: true,
          centeredSlides: true,
        }
      }
    },
    methods: {
      onResize()
      {
        if(window.innerWidth < 768)
        {
          this.isMobile = true
        }else{
          this.isMobile = false
        }
      }
    },
    beforeDestroy()
    {
      window.removeEventListener('resize', this.onResize)
    },
    mounted(){
      this.onResize()
      window.addEventListener('resize', this.onResize)
    }
  }
</script>

<style lang="stylus">
.Presta

    padding 50px 0
    background white

    @media $small
      padding 30px 0

    &_wrapper
      width 90%
      max-width $max-width
      margin 0 auto

    &_top
      display flex
      flex-direction row
      align-items center
      justify-content space-between
      margin-bottom 30px
      color $dark-brown

      @media $small
        flex-direction column

    &_items
      display flex
      flex-direction row
      flex-wrap wrap
      align-items flex-start
      justify-content space-between

</style>
